import React, { Component } from "react";
import PropTypes from "prop-types";
import { Input, Label } from "arv-reactcomponents";
import { PAYMENTPAGE, RegexMethods } from "npmlinks-constants";
import { observer, inject } from "mobx-react";
import PaymentGateway from "../../PaymentGateway";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";

const { UPI_CONSTANTS: { VPA_TEXT, VPA_PLACEHOLDER } } = PAYMENTPAGE;

@inject("RazorpayStore")
@observer
class UPI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      upi: "",
      upiErrorMsg: "",
      showError: false,
    }
    this.onBlur = this.onBlur.bind(this);
    this.validateUpi = this.validateUpi.bind(this);
    this.updateUpi = this.updateUpi.bind(this);
  }
  componentDidMount() {
    const { upiData } = this.props.RazorpayStore;
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.PAYMENT_UPI_ENTERED,
      label: upiData.requestedPG,
    });
  }
  onBlur() {
    this.setState({ showError: true });
  }

  updateUpi(upi, isValid) {
    if (isValid) {
      this.props.RazorpayStore.setUpi(upi);
    }
  }

  validateUpi(e) {
    const validateUpiField = this.validateUpiFieldRef.getValidatedOutput(
      e.target.value,
    );
    this.setState({
      upi: validateUpiField.value,
      upiErrorMsg: validateUpiField.errorMsg,
      showError: false,
    });
    this.updateUpi(validateUpiField.value, validateUpiField.isValid)
  }
  render() {
    const { showError, upiErrorMsg } = this.state;
    const { upiId, paymentData } = this.props.RazorpayStore;
    const paymentDatawithUpi = { ...paymentData, upiId };
    return (
      <div className="nw-upi">
        {upiId &&
          paymentData &&
          paymentData.transactions &&
          paymentData.transactions.banking &&
          <PaymentGateway.component
            success={paymentDatawithUpi}
            componentName="UPI"
          />}
        <Label
          htmlFor="nw-upi-input"
          className="nw-upi-lable"
        >
          {VPA_TEXT}
        </Label>
        <Input
          className="nw-upi-input"
          type="input"
          name="text"
          validateWithPattern={RegexMethods.UPI_REGEX}
          onBlur={this.onBlur}
          onChange={this.validateUpi}
          placeholder={VPA_PLACEHOLDER}
          ref={values => {
            this.validateUpiFieldRef = values;
          }}
        />
        {showError && upiErrorMsg && <div className="nw-upi-err">
          {upiErrorMsg}
        </div>}
      </div>
    )
  }
}

UPI.propTypes = {
  RazorpayStore: PropTypes.shape({
    setUpi: PropTypes.func.isRequired,
    paymentData: PropTypes.shape({}).isRequired,
    upiId: PropTypes.string.isRequired,
    upiData: PropTypes.shape({}).isRequired,
  }).isRequired,
}

const getFinalComponent = component => component;
const ProjectComponent = {
  getFinalComponent,
  component: UPI,
  wrapper: UPI,
}

export default ProjectComponent;


// WEBPACK FOOTER //
// ./src/component/PaymentWallet/UPI/index.js